<template>
    <div
        v-if="ehDev && estaAberto"
        style="
            z-index: 99999999;
            position: absolute;
            top: 0px;
            left: 0px;
            background-color: #000;
            color: #fff;
            font-size: 10px;
            max-height: 66vh;
            max-width: 100vw;
            overflow: auto;
        "
    >
        <h2>Estrutura da Página</h2>
        <pre>{{ $store.state.landingPage.estruturaPagina }}</pre>
        <h2>Id Elemento Selecionado</h2>
        <pre>{{ $store.state.landingPage.idElementoSelecionado }}</pre>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';
const ehDev = process.env.NODE_ENV === 'development';

defineProps({
    estaAberto: {
        type: Boolean,
        required: true,
    },
});
</script>
